import React, {Component} from 'react'
import {withSizes} from 'react-sizes'

const mapSizesToProps = ({ width }) => ({
  isMobile: width < 768,
})

class CourseProgressCircle extends Component {
  constructor(props) {
    super(props)

    this.state = {
      creditPointsCompleted: 0
    }
  }

  componentDidMount() {
    const interval = setInterval(() => {
      if (this.state.creditPointsCompleted >= this.props.creditPointsCompleted) {
        clearInterval(interval)
      } else {
        this.setState({
          creditPointsCompleted: this.state.creditPointsCompleted + 1
        })
      }
    }, 1000 / this.props.creditPointsCompleted)
  }

  onTotalHover = event => {
    this.props.onTotalHover(event.clientX, event.clientY)
  }

  onCompletedHover = event => {
    this.props.onCompletedHover(event.clientX, event.clientY)
  }

  onIncompleteHover = event => {
    this.props.onIncompleteHover(event.clientX, event.clientY)
  }

  onAdvancedStandingHover = event => {
    this.props.onAdvancedStandingHover(event.clientX, event.clientY)
  }

  stopHover = event => {
    this.props.onStop(event)
  }

  render() {
    const {advancedStanding, completedUnits, incompleteUnits} = this.props

    const width = 36
    const height = 36

    const outerCircumference = 100
    const outerRadius = outerCircumference / (Math.PI * 2)
    const outerDiameter = outerRadius * 2

    const innerCircumference = this.props.isMobile ? 82 : 89
    const innerRadius = innerCircumference / (Math.PI * 2)
    const innerDiameter = innerRadius * 2

    const x = width / 2
    const outerY = (height - outerDiameter) / 2
    const innerY = (height - innerDiameter) / 2

    let percentX = x + 1
    if (this.state.creditPointsCompleted >= 100) {
      percentX = x + 5
    } else if (this.state.creditPointsCompleted >= 10) {
      percentX = x + 3
    }

    return (
      <svg viewBox={`0 0 ${width} ${height}`} className="course-progress__circle" aria-labelledby="course-progress-title course-progress-desc" role="img">
        <title id="course-progress-title">Course Completion Progress</title>
        <desc id="course-progress-desc">Chart indicating that the student has in total completed {this.state.creditPointsCompleted}% of the credit points required to finish their course.</desc>

        <path className="outer-circle outer-circle--bg"
              d={`M${x} ${outerY}
          a ${outerRadius} ${outerRadius} 0 0 1 0 ${outerDiameter}
          a ${outerRadius} ${outerRadius} 0 0 1 0 -${outerDiameter}`}
        />

        <path className="outer-circle outer-circle--total"
              strokeDasharray={`${this.state.creditPointsCompleted}, ${outerCircumference}`}
              d={`M${x} ${outerY}
          a ${outerRadius} ${outerRadius} 0 0 1 0 ${outerDiameter}
          a ${outerRadius} ${outerRadius} 0 0 1 0 -${outerDiameter}`}
              aria-labelledby="total-completed-progress-title total-completed-progress-desc"
              onMouseMove={this.onTotalHover}
              onMouseOut={this.stopHover}
        >
          <title id="total-completed-progress-title">Total Completed</title>
          <desc id="total-completed-progress-desc">Chart indicating that the student has in total completed {this.state.creditPointsCompleted}% of the credit points required to finish their course.</desc>
        </path>

        <path className="inner-circle inner-circle--bg"
              d={`M${x} ${innerY}
          a ${innerRadius} ${innerRadius} 0 0 1 0 ${innerDiameter}
          a ${innerRadius} ${innerRadius} 0 0 1 0 -${innerDiameter}`}
        />

        <path className="inner-circle inner-circle--incomplete-units"
              strokeDasharray={`${(advancedStanding + completedUnits + incompleteUnits) * innerCircumference}, ${innerCircumference}`}
              d={`M${x} ${innerY}
          a ${innerRadius} ${innerRadius} 0 0 1 0 ${innerDiameter}
          a ${innerRadius} ${innerRadius} 0 0 1 0 -${innerDiameter}`}
              aria-labelledby="incomplete-units-title incomplete-units-desc"
              onMouseMove={this.onIncompleteHover}
              onMouseOut={this.stopHover}
        >
          <title id="incomplete-units-title">Enrolled</title>
          <desc id="incomplete-units-desc">Chart indicating that the student has currently enrolled in but not completed {incompleteUnits * 100}% of the credit points required to finish their course.</desc>
        </path>

        <path className="inner-circle inner-circle--completed-units"
              strokeDasharray={`${(advancedStanding + completedUnits) * innerCircumference}, ${innerCircumference}`}
              d={`M${x} ${innerY}
          a ${innerRadius} ${innerRadius} 0 0 1 0 ${innerDiameter}
          a ${innerRadius} ${innerRadius} 0 0 1 0 -${innerDiameter}`}
              aria-labelledby="completed-units-title completed-units-desc"
              onMouseMove={this.onCompletedHover}
              onMouseOut={this.stopHover}
        >
          <title id="completed-units-title">Passed</title>
          <desc id="completed-units-desc">Chart indicating that the student has successfully passed {completedUnits * 100}% of the credit points required to finish their course.</desc>
        </path>

        <path className="inner-circle inner-circle--advanced-standing"
              strokeDasharray={`${advancedStanding * innerCircumference}, ${innerCircumference}`}
              d={`M${x} ${innerY}
          a ${innerRadius} ${innerRadius} 0 0 1 0 ${innerDiameter}
          a ${innerRadius} ${innerRadius} 0 0 1 0 -${innerDiameter}`}
              aria-labelledby="advanced-standing-title advanced-standing-desc"
              onMouseMove={this.onAdvancedStandingHover}
              onMouseOut={this.stopHover}
        >
          <title id="advanced-standing-title">Advanced standing</title>
          <desc id="advanced-standing-desc">Chart indicating that the student received {advancedStanding * 100}% of the credit points required to finish their course through advanced standing.</desc>
        </path>

        <text x={percentX} y={19} className="percentage">{this.state.creditPointsCompleted}</text>
        <text x={percentX} y={19} className="percentage-sign">%</text>
        <text x={x} y="23" className="complete-txt">COMPLETE</text>
      </svg>
    )
  }
}

export default withSizes(mapSizesToProps)(CourseProgressCircle)
